import CustomHookFactory from "./CustomHookFactory";

export default CustomHookFactory("UserInstitution", ["default"]);
